import AuthService from "../../service/AuthService";
// import this.$swal from 'sweetalert'
// import store from '../store'
import router from "../../router";

//export const namespaced = true

export const state = {
    q_auth:null,
    isDocumentsUpt: false,
    authLoading: false,
    screen: 'login',
    loginScreen: 'login',
    regScreen: 'reg',
    response:{}

}


export const getters = {
    getTok: state => {
        // console.log("getter getTok")
        return state.q_auth
    }
}


export const mutations = {
    updateResponse:(state, payload) =>{
        state.response = payload
    }, 

    updateAuthLoading: (state, payload) =>{
        state.authLoading = payload
    },

    updateScreen: (state, payload) =>{
        state.screen = payload
    },

    updateLoginScreen: (state, payload) =>{
        state.loginScreen = payload
    },

    updateRegScreen: (state, payload) =>{
        state.regScreen = payload
    },

    updateAuthToken: (state, payload) =>{
        // console.log("mutation updateAuthToken ==>>", payload)
        state.q_auth = payload
    },

    // eslint-disable-next-line no-unused-vars
    reset: (state, payload) =>{
        state.q_auth = null;
        state.isDocumentsUpt = false;
        state.authLoading = false;
        state.screen = 'login';
        state.regScreen = 'reg';
        state.response ={};
    },
}


export const actions = {
    logon: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callLogonApi(payload)
        .then(response => {
            commit("updateAuthLoading", false)
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responseCode === "00") {
                localStorage.q_auth = responseData.authorization;
                localStorage.username = responseData.username;
                commit("updateAuthToken", responseData.authorization)
            }else if (responseData.responseCode === "01") {
                const options = {title: 'Info!', size: 'sm'};
                dialogs.alert('Please enter the otp you got on your phone and change your password as well...', options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                        commit("updateLoginScreen", 'otp')
                    });

            }else{
                const options = {title: 'Error!', size: 'sm'};
                dialogs.alert(responseData.responseMessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                    });
            }
            
        })
        .catch((error) => {
            commit("updateAuthLoading", false)
            alert(error);
            // throw error;
            // return Promise.reject(error)
        });
    },

    initiateResetPassword: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callInitiateResetPasswordApi(payload)
        .then(response => {
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responsecode === "00") {
                commit("updateAuthLoading", false)
                localStorage.clear()
                const options = {title: 'Info!', size: 'sm'};
                dialogs.alert('Otp has been sent to your phone, please supply it to proceed', options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                        commit("updateScreen",'recovery2')
                    });

            }else{
                commit("updateAuthLoading", false)
                const options = {title: 'Error!', size: 'sm'};
                dialogs.alert(responseData.responsemessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                    });
            }
            
        })
        .catch(error => {
            commit("updateAuthLoading", false)
            alert(error);
            // throw error;
        });
    },

    completeResetPassword: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        return AuthService.callCompleteResetPasswordApi(payload)
            .then(response => {
                let responseData = response.data;
                commit("updateAuthLoading", false)
                if (responseData.responsecode === "00") {
                    localStorage.clear();
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(responseData.responsemessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res); // {ok: true|false|undefined}
                            router.push('/');
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responsemessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res); // {ok: true|false|undefined}
                            router.push('/');
                        });
                }

            })
            .catch(error => {
                commit("updateAuthLoading", false)
                alert(error);
                // throw error;
            });
    },

    verifyToken: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        return AuthService.callVerifyTokenApi(payload)
        .then(response => {
            let responseData = response.data;
            commit("updateAuthLoading", false)
            if (responseData.responseCode === "00") {
                // console.log("callVerifyTokenApi responseData ==>>", responseData);
                localStorage.clear()
                const options = {title: 'Info!', size: 'sm'};
                dialogs.alert('Otp verified, set your password to proceed to login.', options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                        commit("updateScreen",'recovery3')
                    });
            }else{
                const options = {title: 'Error!', size: 'sm'};
                dialogs.alert(responseData.responseMessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                    });
            }
            
        })
        .catch(error => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },

    changePassword: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        return AuthService.callChangePasswordApi(payload)
        .then(response => {
            let responseData = response.data;
            commit("updateAuthLoading", false)
            if (responseData.responseCode === "00") {
                localStorage.clear()
                const options = {title: 'Success!', size: 'sm'};
                dialogs.alert(responseData.responseMessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                        //router.push('/')
                    });
            }else{
                const options = {title: 'Error!', size: 'sm'};
                dialogs.alert(responseData.responseMessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                    });
            }
            
        })
        .catch(error => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },

    initiateEnrollment: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callInitiateEnrollmentApi(payload)
        .then(response => {
            commit("updateAuthLoading", false)
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responseCode === "00") {
                const options = {title: 'Info!', size: 'sm'};
                dialogs.alert('Otp has been sent to your phone, please supply it to proceed', options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res); // {ok: true|false|undefined}
                        commit("updateRegScreen", 'otp')
                    });
            }else{
                const options = {title: 'Error!', size: 'sm'};
                dialogs.alert(responseData.responseMessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res); // {ok: true|false|undefined}
                        router.push('/');
                    });
            }
            
        })
        .catch((error) => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },

    completeEnrollment: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callCompleteEnrollmentApi(payload)
        .then(response => {
            commit("updateAuthLoading", false)
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responseCode === "00") {
                commit("updateResponse", responseData)
                const options = {title: 'Info!', size: 'sm'};
                dialogs.alert('Congratulations, enrollment has been completed successfully, proceed to login', options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res); // {ok: true|false|undefined}
                        router.push('/')
                    });
            }else{
                const options = {title: 'Error!', size: 'sm'};
                dialogs.alert(responseData.responseMessage, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res); // {ok: true|false|undefined}
                        //router.push('/');
                    });
            }
            
        })
        .catch((error) => {
            commit("updateAuthLoading", false)
            alert(error);
            // throw error;
            // return Promise.reject(error)
        });
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }

}
